module.exports = "<img [src]=\"dataUrl$|async\"/>"